import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=50ddea06&scoped=true"
import script from "./Special.vue?vue&type=script&lang=js"
export * from "./Special.vue?vue&type=script&lang=js"
import style0 from "./Special.vue?vue&type=style&index=0&id=50ddea06&prod&scoped=true&lang=css"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=50ddea06&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ddea06",
  null
  
)

export default component.exports